import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_INVOICE_CLIENT_ITEM_RESET   = 'DELETE_INVOICE_CLIENT_ITEM_RESET';
export const DELETE_INVOICE_CLIENT_ITEM_LOADING = 'DELETE_INVOICE_CLIENT_ITEM_LOADING';
export const DELETE_INVOICE_CLIENT_ITEM_SUCCESS = 'DELETE_INVOICE_CLIENT_ITEM_SUCCESS';
export const DELETE_INVOICE_CLIENT_ITEM_REJECT  = 'DELETE_INVOICE_CLIENT_ITEM_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteInvoiceClientItemReset   = () => ({ type: DELETE_INVOICE_CLIENT_ITEM_RESET });
export const deleteInvoiceClientItemLoading = () => ({ type: DELETE_INVOICE_CLIENT_ITEM_LOADING });
export const deleteInvoiceClientItemSuccess = (payload) => ({ type: DELETE_INVOICE_CLIENT_ITEM_SUCCESS, payload });
export const deleteInvoiceClientItemReject  = (payload) => ({ type: DELETE_INVOICE_CLIENT_ITEM_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const deleteInvoiceClientItemRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        params,
    }, getState);
    return request(`/Invoices/web/DeleteInvoicesLine`, options);
};
